import apiClient from '@/services/axios'

export const put = async (reorderData) => {
    const response = await apiClient.put('/mediaspace/reorder', reorderData)
    return response.data
} 